export default "__VITE_ASSET__CKn2Equ7__"